import { render, staticRenderFns } from "./JSqlCodeEditorDyn.vue?vue&type=template&id=bd81aeec"
import script from "./JSqlCodeEditorDyn.vue?vue&type=script&lang=js"
export * from "./JSqlCodeEditorDyn.vue?vue&type=script&lang=js"
import style0 from "./JSqlCodeEditorDyn.vue?vue&type=style&index=0&id=bd81aeec&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd81aeec')) {
      api.createRecord('bd81aeec', component.options)
    } else {
      api.reload('bd81aeec', component.options)
    }
    module.hot.accept("./JSqlCodeEditorDyn.vue?vue&type=template&id=bd81aeec", function () {
      api.rerender('bd81aeec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/dynamic/JSqlCodeEditorDyn.vue"
export default component.exports